import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-order",
  "use": "icon-order-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-order\"><defs><style type=\"text/css\"></style></defs><path d=\"M755.2 81.066667H268.8C192 81.066667 128 145.066667 128 226.133333v576c0 76.8 64 140.8 140.8 140.8h482.133333c76.8 0 140.8-64 140.8-140.8V226.133333c4.266667-81.066667-59.733333-145.066667-136.533333-145.066666z m-145.066667 499.2c0 17.066667-12.8 29.866667-29.866666 29.866666H285.866667c-17.066667 0-29.866667-12.8-29.866667-29.866666v-12.8c0-17.066667 12.8-29.866667 29.866667-29.866667h294.4c17.066667 0 29.866667 12.8 29.866666 29.866667v12.8z m123.733334-170.666667H290.133333c-17.066667 0-34.133333-17.066667-34.133333-34.133333 0-21.333333 17.066667-34.133333 34.133333-34.133334h439.466667c21.333333 0 38.4 12.8 38.4 34.133334 0 17.066667-17.066667 34.133333-34.133333 34.133333z\" p-id=\"3637\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/order.svg
// module id = gYtG
// module chunks = 19